import { MarksByPercentage } from './types';

// Preset mark configurations needed for cases where default marks generating logic doesn't produce the desired values
const PRESET_LEVERAGE_MARKS: Record<number, MarksByPercentage> = {
	5: {
		0: { value: 0, label: '1x' },
		25: { value: 25, label: '2x' },
		50: { value: 50, label: '3x' },
		75: { value: 75, label: '4x' },
		100: { value: 100, label: '5x' },
	},
	4: {
		0: { value: 0, label: '1x' },
		33: { value: 33, label: '2x' },
		66: { value: 66, label: '3x' },
		100: { value: 100, label: '4x' },
	},
	3: {
		0: { value: 0, label: '1x' },
		50: { value: 50, label: '2x' },
		100: { value: 100, label: '3x' },
	},
	101: {
		0: { value: 0, label: '1x' },
		20: { value: 20, label: '20x' },
		40: { value: 40, label: '40x' },
		60: { value: 60, label: '60x' },
		80: { value: 80, label: '80x' },
		100: { value: 100, label: '101x' },
	},
};

/**
 * Creates leverage-based marks for slider based on maximum leverage value
 */
export function createLeverageMarks(maxLeverage: number): MarksByPercentage {
	const maxLev = Math.max(1, Math.round(Math.min(maxLeverage, 101)));

	// Use preset marks if available
	if (PRESET_LEVERAGE_MARKS[maxLev]) {
		return PRESET_LEVERAGE_MARKS[maxLev];
	}

	// Generate dynamic marks for other values
	const ticksCount = Math.min(maxLev, 6);

	// If only 1x leverage is possible, show a single tick at 0%
	if (ticksCount === 1) {
		return { 0: { value: 0, label: '1x' } };
	}

	const marks: MarksByPercentage = {};
	for (let i = 0; i < ticksCount; i++) {
		const pct = Math.round((i / (ticksCount - 1)) * 100);
		const pctRounded = pct > 10 && pct < 100 ? Math.round(pct / 10) * 10 : pct;
		const labelLev =
			i === ticksCount - 1
				? maxLev
				: Math.max(1, Math.round((pctRounded / 100) * maxLev));

		marks[pct] = {
			value: pctRounded,
			label: `${labelLev}x`,
		};
	}

	return marks;
}

export function parseLeverageFromLabel(label: string): number {
	return parseFloat(label.replace('x', ''));
}
